import { render, staticRenderFns } from "./BaseText.vue?vue&type=template&id=20e6036a&scoped=true"
import script from "./BaseText.vue?vue&type=script&lang=js"
export * from "./BaseText.vue?vue&type=script&lang=js"
import style0 from "./BaseText.vue?vue&type=style&index=0&id=20e6036a&lang=scss&scoped=true&module=true"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./BaseText.vue?vue&type=style&index=0&id=20e6036a&lang=scss&scoped=true&module=true"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("./BaseText.vue?vue&type=style&index=0&id=20e6036a&lang=scss&scoped=true&module=true")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js").rerender("20e6036a")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "20e6036a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20e6036a')) {
      api.createRecord('20e6036a', component.options)
    } else {
      api.reload('20e6036a', component.options)
    }
    module.hot.accept("./BaseText.vue?vue&type=template&id=20e6036a&scoped=true", function () {
      api.rerender('20e6036a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ui/atoms/baseText/BaseText.vue"
export default component.exports